import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import trophyPic from "assets/icons/trophy.svg";
import Button from "components/common/Button/Button";
import Text from "components/common/Text/Text";
import Title from "components/common/Title";
import Content from "components/Content";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { Routes } from "router";
import { load } from "utils/ConfigLoader";

const Congrats = () => {
  const pointsEarned = load("signup.pointsEarned");
  const operationMode = load("tablet.operationMode");
  return (
    <Content fullScreen>
      <Row>
        <Link to={operationMode === "KIOSK" ? "/kiosk" : "/"}>
          <FontAwesomeIcon icon="times" size="3x" style={{ color: "gray" }} />
        </Link>
      </Row>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "calc(100vh - 150px)"
        }}
      >
        <Row>
          <Col align="center">
            <Title style={{ fontWeight: 100 }}>
              Congrats, your just earned
            </Title>
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              <Col align="center" style={{ marginRight: 30 }}>
                <Title noPadding bold style={{ marginTop: -5 }}>
                  {pointsEarned}
                </Title>
                <Text>Points</Text>
              </Col>
              <img src={trophyPic} alt="trophy" />
            </div>
          </Col>
        </Row>
        <Row>
          <Col align="center">
            <Link to={Routes.Main}>
              <Button primary wide>
                Woot woot!
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
    </Content>
  );
};

export default Congrats;



// WEBPACK FOOTER //
// ./src/screens/Congrats.tsx